// データパネル関連のユーティリティ関数

// Disasterreportsで使用する日付プロパティの候補
const DATE_PROP = '投稿日時';

/**
 * Disasterreports（災害パトロール）かどうかを判定
 * @param feature
 * @returns Disasterreportsの場合true
 */
export const isDisasterReports = (feature: maplibregl.MapGeoJSONFeature): boolean => {
  return feature.source === 'Disasterreports' || 
         feature.layer.id.includes('Disasterreports');
};

/**
 * feature配列を日付降順でソート
 * @param features
 * @returns 日付降順でソートされたfeature
 */
export const sortFeaturesByDate = (features: maplibregl.MapGeoJSONFeature[]): maplibregl.MapGeoJSONFeature[] => {
  return [...features].sort((a, b) => {
    const dateA = a.properties[DATE_PROP];
    const dateB = b.properties[DATE_PROP];
      if (dateA && dateB) {
        try {
          return new Date(dateB).getTime() - new Date(dateA).getTime();
        } catch (error) {
          console.warn('日付のソートでエラーが発生しました:', error);
          return 0;
        }
      }
      return 0
  });
};

/**
 * Disasterreportsが含まれている場合のみソートを適用
 * @param features
 * @returns 必要に応じてソートされた配列
 */
export const sortDisasterReportsIfNeeded = (features: maplibregl.MapGeoJSONFeature[]): maplibregl.MapGeoJSONFeature[] => {
  const hasDisasterReports = features.some(isDisasterReports);
  return hasDisasterReports ? sortFeaturesByDate(features) : features;
};